import { Fragment } from 'react'
import PropTypes from 'prop-types'

import * as SVG from './Icons'

const ICONS = [
  {
    name: 'arrow-down',
    component: <SVG.ArrowDown />
  },
  {
    name: 'calendar',
    component: <SVG.Calendar />
  },
  {
    name: 'content',
    component: <SVG.Content />
  },
  {
    name: 'coupon',
    component: <SVG.Coupon />
  },
  {
    name: 'course',
    component: <SVG.Course />
  },
  {
    name: 'gift',
    component: <SVG.Gift />
  },
  {
    name: 'logo',
    component: <SVG.Logo />
  },
  {
    name: 'enjoy',
    component: <SVG.Enjoy />
  },
  {
    name: 'points',
    component: <SVG.Points />
  },
  {
    name: 'checkbox',
    component: <SVG.CheckBox />
  }
]

const Icon = ({ name }) => (
  <Fragment>
    <SVG.LinearGradient /> {/* only to prevent multiple linears */}
    {ICONS.map(item =>
      item.name.includes(name)
        ? (<Fragment key={item.name}>{item.component}</Fragment>)
        : null
    )}
  </Fragment>
)

Icon.propTypes = {
  name: PropTypes.oneOf([
    'calendar',
    'content',
    'coupon',
    'course',
    'gift',
    'logo',
    'arrow-down',
    'enjoy',
    'points',
    'checkbox'
  ])
}

export default Icon
